/**
 * Lightweight area-code → blog slug map for client and middleware.
 * Keep in sync when adding area-code blogs (or re-run scripts/generate-area-code-blog-map.mjs).
 */
export const AREA_CODE_BLOG_SLUGS: Record<string, string> = {
  "225": "225-area-code-location-time-zone-history-scams-and-uses",
  "231": "231-area-code-location-time-zone-history-scams-and-uses",
  "239": "239-area-code-location-time-zone-history-and-scams",
  "249": "249-area-code-location-time-zone-history-scams-and-uses",
  "270": "270-area-code-location-time-zone-history-scams-and-uses",
  "301": "301-area-code-location-time-zone-history-scams-and-business-benefits",
  "306": "306-area-code-location-time-zone-history-and-scams",
  "316": "316-area-code-location-time-zone-history-and-scams",
  "325": "325-area-code-location-time-zone-history-scams-and-uses",
  "334": "334-area-code-location-time-zone-history-scams-and-uses",
  "336": "336-area-code-location-time-zone-history-and-scams",
  "337": "337-area-code-location-time-zone-history-and-scams",
  "360": "360-area-code-location-time-zone-history-scams-and-uses",
  "361": "361-area-code-location-time-zone-history-scams-and-uses",
  "403": "403-area-code-location-time-zone-history-and-scams",
  "405": "405-area-code-location-time-zone-history-scams-and-uses",
  "407": "407-area-code-location-time-zone-history-scams-and-uses",
  "413": "413-area-code-location-time-zone-history-scams-and-uses",
  "416": "416-area-code-location-time-zone-history-and-scams",
  "419": "419-area-code-location-time-zone-history-scams-and-uses",
  "434": "434-area-code-location-time-zone-history-scams-and-uses",
  "440": "440-area-code-location-time-zone-history-scams-and-uses",
  "478": "478-area-code-location-time-zone-history-scams-and-uses",
  "509": "509-area-code-location-time-zone-history-and-scams",
  "514": "514-area-code-location-time-zone-history-and-scams",
  "587": "587-area-code-location-time-zone-history-and-scams",
  "602": "602-area-code-location-time-zone-history-scams-and-uses",
  "607": "607-area-code-location-time-zone-history-uses-and-scams",
  "613": "613-area-code-location-time-zone-history-and-scams",
  "616": "616-area-code-location-time-zone-history-and-scams",
  "618": "618-area-code-location-time-zone-history-and-scams",
  "636": "636-area-code-location-time-zone-history-scams-and-uses",
  "651": "651-area-code-location-time-zone-history-and-scams",
  "705": "705-area-code-location-time-zone-history-and-scams",
  "708": "708-area-code-location-time-zone-history-scams-and-uses",
  "715": "715-area-code-location-time-zone-history-scams-and-uses",
  "727": "727-area-code-location-time-zone-history-and-scams",
  "778": "778-area-code-location-time-zone-history-and-scams",
  "786": "786-area-code-location-time-zone-history-and-scams",
  "801": "801-area-code-location-time-zone-history-scams-and-uses",
  "802": "802-area-code-location-time-zone-history-scams-and-uses",
  "806": "806-area-code-location-time-zone-history-scams-and-uses",
  "807": "807-area-code-location-time-zone-history-scams-and-uses",
  "819": "819-area-code-location-time-zone-history-and-scams",
  "825": "825-area-code-location-time-zone-history-scams-and-uses",
  "828": "828-area-code-location-time-zone-history-scams-and-uses",
  "859": "859-area-code-location-time-zone-history-scams-and-uses",
  "864": "864-area-code-location-time-zone-history-scams-and-uses",
  "876": "876-area-code-location-time-zone-history-and-scams",
  "902": "902-area-code-location-time-zone-history-scams-and-uses",
  "908": "908-area-code-location-time-zone-history-scams-and-uses",
  "910": "910-area-code-location-time-zone-history-scams-and-uses",
  "912": "912-area-code-location-time-zone-history-scams-and-uses",
  "937": "937-area-code-location-time-zone-history-and-scams",
  "939": "939-area-code-location-time-zone-history-scams-and-uses",
  "940": "940-area-code-location-time-zone-history-and-scams",
  "941": "941-area-code-location-time-zone-history-scams-and-uses",
  "956": "956-area-code-location-time-zone-history-uses-and-scams",
  "984": "984-area-code-location-time-zone-history-scams-and-uses",
  "989": "989-area-code-location-time-zone-history-and-scams"
};
